import { registerCollisionAnimation } from './CollisionAnimationRegistry';

registerCollisionAnimation('SUPERNOVA', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  if (progress < 0.2) {
    ctx.fillStyle = '#fff';
    ctx.globalAlpha = 1 - (progress / 0.2);
    ctx.beginPath(); ctx.arc(e.pos.x, e.pos.y, e.radius * 3, 0, Math.PI * 2); ctx.fill();
  }
  ctx.strokeStyle = determineColor(0, 1);
  ctx.lineWidth = 10 * (1 - progress);
  ctx.globalAlpha = 1 - progress;
  ctx.beginPath(); ctx.arc(e.pos.x, e.pos.y, e.radius + progress * 300, 0, Math.PI * 2); ctx.stroke();
});
